






import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";

@Component
export default class BaseDialog extends EditPage {
  public mounted() {
     if (this.siteData.aic) {
      this.aic = this.siteData.aic;
    }
  }

}
